import JarvisHttpService from "Jarvis/JarvisServices/JarvisHttpService";
import JarvisBaseSettingsService from "Jarvis/JarvisServices/JarvisBaseSettingsService";

/**
 * The environment the server runs as - the Environment of the Launcher's Jarvis.Base.Settings.json:
 * DEV, UAT, DEMO or LIVE. Anonymous, so it works before login.
 */
export const EnvironmentRetrieve = async () => {
  const { data } = await JarvisHttpService.post({
    url: JarvisBaseSettingsService.getApiEndPoint("Jarvis") + "Pub/Environment/Retrieve",
  });
  return data;
};
